const MapContact = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Find Us & <span className="text-yellow-600">Get In Touch</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Located in Brampton, Ontario, we serve the entire GTA with professional electrical services.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Map */}
          <div className="bg-gray-100 rounded-lg overflow-hidden shadow-md">
            <iframe
              src="https://maps.app.goo.gl/DdN8vrAz3ZHGDQgbA"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="OhmEx Electric Location"
            ></iframe>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Contact Information</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center">
                    <i className="ri-map-pin-fill text-yellow-600"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">Location</p>
                    <a
                      href="https://maps.app.goo.gl/DdN8vrAz3ZHGDQgbA"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-yellow-600 hover:text-yellow-700 cursor-pointer"
                    >
                      32 Poplar Plains Rd, Brampton, L7A 1Z5, Ontario
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-whatsapp-fill text-green-600"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">WhatsApp</p>
                    <a
                      href="https://wa.me/16472442797"
                      className="text-green-600 hover:text-green-700 cursor-pointer"
                    >
                      +1 647-244-2797
                    </a>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                    <i className="ri-time-fill text-blue-600"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-900">Service Hours</p>
                    <p className="text-gray-600">24/7 Emergency Service Available</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <a
                href="https://wa.me/16472442797?text=Hi%20OhmEX%20Electric!%20I%20would%20like%20to%20speak%20with%20you."
                className="w-full bg-yellow-400 text-black px-6 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-500 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center space-x-2"
              >
                <i className="ri-phone-fill"></i>
                <span>Call Now: +1 647-244-2797</span>
              </a>
              <a
                href="https://wa.me/16472442797?text=Hi%20OhmEX%20Electric!%20I%20would%20like%20to%20inquire%20about%20your%20electrical%20services."
                className="w-full bg-green-600 text-white px-6 py-4 rounded-lg text-lg font-semibold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center space-x-2"
              >
                <i className="ri-whatsapp-fill"></i>
                <span>Message on WhatsApp</span>
              </a>
            </div>

            <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
              <p className="text-sm text-yellow-800">
                <strong>Service Area:</strong> We proudly serve Brampton, Mississauga, Toronto, 
                Durham Region, and the entire Greater Toronto Area (GTA).
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapContact;
